import Container from "../ui/container";
import LongText from "../ui/LongText";
import styles from "./Home_1.module.css";
import { motion } from "framer-motion";
import babyCloud from "../../assets/images/home_1/Asset 40@2x.png";
import sun from "../../assets/images/home_1/Asset 44@2x.png";
import starRight from "../../assets/images/home_1/Asset 45@2x.png";
import bottle from "../../assets/images/home_1/Asset 46@2x.png";
import starLeft from "../../assets/images/home_1/Asset 48@2x.png";
import butterfly from "../../assets/images/home_1/Asset 41@2x.png";
import lightRight from "../../assets/images/home_1/Asset 42@2x.png";
import lightLeft from "../../assets/images/home_1/Asset 43@2x.png";
import main from "../../assets/images/home_1/Asset 47@2x.png";
import p1 from "../../assets/images/product/Asset 4@2x.png";
import p2 from "../../assets/images/product/Asset 5@2x.png";
import p3 from "../../assets/images/product/Asset 6@2x.png";
import main1BG from "../../assets/images/home_1_bg/3x/Asset 4@3x.png";
import main2BG from "../../assets/images/home_1_bg/3x/Asset 5@3x.png";
import { useTranslation } from "../../context/LanguageContext";

function Home1() {
  const { translate } = useTranslation();

  return (
    <section className={`${styles.background} bg-[#fffaf3]`}>
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      <div className="w-full max-w-[1920px] relative mx-auto">
        <motion.div
          className={styles.baby_cloud}
          initial={{ opacity: 0, x: -10, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, x: 0, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={babyCloud} alt="baby_cloud" width={180} height={112} />
        </motion.div>

        <motion.div
          className={styles.sun}
          initial={{ opacity: 0, y: -40, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={sun} alt="sun" width={221} height={171} />
        </motion.div>
        <motion.div
          className={styles.star_right}
          initial={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={starRight} alt="star_right" width={38} height={35} />
        </motion.div>
        <motion.div
          className={styles.bottle}
          initial={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={bottle} alt="bottle" width={70} height={97} />
        </motion.div>

        <motion.div
          className={styles.star_left}
          initial={{ opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <img src={starLeft} alt="star_left" width={62.4} height={70.52} />
        </motion.div>
        {/*  */}
        {/*  */}
        {/*  */}
        {/*  */}
        {/*  */}
        {/*  */}
        <Container>
          <div className="w-[900px] relative">
            <div className="relative">
              <h2 className="text-[128px] leading-[1] font-bold text-black mb-2.5">
                {translate("home.title")}
              </h2>
              <motion.div
                className={styles.butterfly}
                initial={{ opacity: 0, y: -2, scale: 0.5 }}
                transition={{ duration: 0.5 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true }}
              >
                <img src={butterfly} alt="butterfly" width={38.4} height={27} />
              </motion.div>
            </div>
            <div className="relative text-center w-[846px]">
              <div>
                <LongText
                  text={translate("home.description")}
                  className="text-[98.2625px] font-semibold"
                />
              </div>
              <motion.div
                className={styles.light_right}
                initial={{ opacity: 0, x: -10 }}
                transition={{ duration: 0.5 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
              >
                <img
                  src={lightRight}
                  alt="light_right"
                  width={41}
                  height={37}
                />
              </motion.div>
              <motion.div
                className={styles.light_left}
                initial={{ opacity: 0, x: 10 }}
                transition={{ duration: 0.5 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
              >
                <img
                  src={lightLeft}
                  alt="light_left"
                  width={33.3}
                  height={43.1}
                />
              </motion.div>
            </div>
            <div className={styles.main}>
              <img
                className="mx-auto"
                src={main}
                alt="main"
                width={749}
                height={417}
              />
            </div>
            {/* Bỉmmmmmm */}
            <div className="absolute w-full top-0 left-full">
              <motion.div
                className="absolute top-0 left-0"
                initial={{ opacity: 0, y: -40 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
              >
                <img src={p1} alt="p1" width={345} height={414} />
              </motion.div>
              <motion.div
                className="absolute top-[50px] left-[100px]"
                initial={{ opacity: 0, y: -40, x: 0 }}
                whileInView={{
                  opacity: 1,
                  y: 75,
                  x: 91,
                }}
                transition={{
                  y: {
                    duration: 0.6,
                    ease: "easeOut",
                  },
                  x: {
                    duration: 0.6,
                    ease: "easeOut",
                  },
                  default: { ease: "easeOut" },
                }}
                viewport={{ once: true }}
              >
                <img src={p2} alt="p2" width={372} height={446} />
              </motion.div>
              <motion.div
                className="absolute 0 left-0"
                initial={{ opacity: 0, y: -40, x: 0 }}
                whileInView={{
                  opacity: [1, 1],
                  y: [100, 335], // Từ 0, đến 50, đến 100
                  x: [100, -47], // Từ 0, đến 100, đến 0
                }}
                transition={{
                  y: {
                    duration: 1.2,
                    ease: "easeOut",
                  },
                  x: {
                    duration: 1.2,
                    ease: "easeOut",
                  },
                  default: { ease: "easeOut" },
                }}
                viewport={{ once: true }}
              >
                <img src={p3} alt="p3" width={456} height={517} />
              </motion.div>
            </div>
          </div>
        </Container>
        {/* BG Bottom */}
        {/* BG Bottom */}
        {/* BG Bottom */}
        <motion.div
          className={styles.main_1}
          initial={{ opacity: 0, rotateX: 0, y: 0, left: 0, bottom: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          whileInView={{
            opacity: 1,
            rotateX: 0,
            y: 0,
            left: 0,
            bottom: 77,
          }}
          viewport={{ once: true }}
        >
          <img
            className="opacity-0"
            src={main1BG}
            alt="bg_pink"
            width={1920}
            height={294}
          />
        </motion.div>
        <motion.div
          className={styles.main_2}
          initial={{ opacity: 0, y: 20, left: 0, bottom: 0 }}
          transition={{ duration: 0.5 }}
          whileInView={{
            opacity: 1,
            y: 0,
            left: 0,
            bottom: -38,
          }}
          viewport={{ once: true }}
        >
          <img
            className="opacity-0"
            src={main2BG}
            alt="bg_yellow"
            width={1920}
            height={194}
          />
        </motion.div>
      </div>
    </section>
  );
}

export default Home1;
